import React, { useEffect, useState } from "react";

export const TimerRing = ({
    total = 60,
    startedAt = null,
    paused = false,
    onComplete,
    size = 320,
}) => {
    const [now, setNow] = useState(Date.now());

    useEffect(() => {
        if (!startedAt || paused) return;
        const id = setInterval(() => setNow(Date.now()), 250);
        return () => clearInterval(id);
    }, [startedAt, paused]);

    let elapsed = 0;
    if (startedAt) {
        elapsed = Math.min(total, Math.floor((now - startedAt) / 1000));
    }
    const remaining = Math.max(0, total - elapsed);
    const progress = total > 0 ? remaining / total : 0;

    useEffect(() => {
        if (startedAt && remaining === 0 && !paused) onComplete?.();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [remaining]);

    const radius = size / 2 - 14;
    const circ = 2 * Math.PI * radius;
    const offset = circ * (1 - progress);

    const minutes = Math.floor(remaining / 60);
    const seconds = remaining % 60;

    return (
        <div
            className="relative flex items-center justify-center"
            style={{ width: size, height: size }}
            data-testid="student-timer-ring"
        >
            <svg
                width={size}
                height={size}
                className="-rotate-90"
                viewBox={`0 0 ${size} ${size}`}
            >
                <defs>
                    <linearGradient id="timerGrad" x1="0" y1="0" x2="1" y2="1">
                        <stop offset="0%" stopColor="#B8E8E8" />
                        <stop offset="100%" stopColor="#5BC2CC" />
                    </linearGradient>
                </defs>
                <circle
                    cx={size / 2}
                    cy={size / 2}
                    r={radius}
                    fill="none"
                    stroke="#E0F4F4"
                    strokeWidth={14}
                />
                <circle
                    cx={size / 2}
                    cy={size / 2}
                    r={radius}
                    fill="none"
                    stroke="url(#timerGrad)"
                    strokeWidth={14}
                    strokeLinecap="round"
                    strokeDasharray={circ}
                    strokeDashoffset={offset}
                    style={{ transition: "stroke-dashoffset 0.35s linear" }}
                />
            </svg>
            <div className="absolute inset-0 flex flex-col items-center justify-center">
                <span className="text-7xl font-semibold tracking-tight text-[#14202a] tabular-nums">
                    {String(minutes).padStart(1, "0")}:
                    {String(seconds).padStart(2, "0")}
                </span>
                <span className="mt-2 text-sm uppercase tracking-[0.25em] text-[#4a5662]">
                    {paused ? "Paused" : startedAt ? "Time left" : "Ready"}
                </span>
            </div>
        </div>
    );
};

export default TimerRing;
